export default {
  createExamStudent: '/examStudent/create',
  getBacklogExamStudentsForAnExam: '/examStudent/getBacklogExamStudentsForAnExam',
  getExamAnalysis: '/examStudent/getExamAnalysis',
  getExamStudentForAnExam: '/examStudent/getExamStudentForAnExam',
  generateStudentMarksExcel: '/excel/exam/generateStudentMarksExcel'
}
